<template>
  <div class="chat--balloon-wrapper" :class="type" ref="element">
    <div 
      class="chat--balloon" 
      :class="`chat--balloon ${type}`" 
      ref="element"
    >
      <div class="dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="inner-text">
        <div class="answer-icon" v-if="icon">
          <img src="../assets/question-icon.svg" />
        </div>
        <div class="balloon-content" >
          <p v-html="text"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {gsap,  Power2} from 'gsap'

export default {
  name: 'ChatBalloon',
  props: ['type', 'text', 'store', 'icon'],
  data(){
    return{
    }
  },
  methods: {
    transitionIn(){
      let TL = new gsap.timeline();
      let balloon = this.$refs.element.querySelector('.chat--balloon');
      let balloonInnerHeight = balloon.offsetHeight;
      let balloonInnerWidth = balloon.clientWidth;
      let balloonInnerText = this.$refs.element.querySelector('.inner-text');
      let dots = this.$refs.element.querySelector('.dots');
      
      let actionPos = this.type === 'bot' ? 'updateEarthPos' : 'updateAvatarPos';

      var body = document.body;
      var docEl = document.documentElement;
      var maxWidthBalloon = window.innerWidth > 767 ? 504 : 300

      gsap.set(this.$refs.element,{width: 0, height: dots.clientHeight + 34, opacity: 1});
      gsap.set(balloonInnerText,{opacity: 0});
      
      TL
      .to(this.$refs.element, { width: 100, duration: .5, ease:Power2.easeInOut,
        onStart: () => {
            
          gsap.to(dots,{delay: .25, duration: .25, opacity:1})
          gsap.set(balloon,{height: dots.clientHeight + 34})
          this.$store.dispatch('triggerScrollWindow', balloonInnerHeight);
        },
        
      })
      .to(this.$refs.element, { delay: .25, width: (balloonInnerWidth + 20) > maxWidthBalloon ? maxWidthBalloon : (balloonInnerWidth + 20), height: balloonInnerHeight, duration: .15,
        onStart: () =>{
          
        },
        onComplete: () => {
          gsap.set(dots,{autoAlpha:0});
          gsap.to(balloon,{width: (balloonInnerWidth + 10) > maxWidthBalloon ? maxWidthBalloon : (balloonInnerWidth + 10),height: balloonInnerHeight, duration: .25, ease:Power2.easeInOut});
          
          let rectElement = this.$refs.element.getBoundingClientRect();
          var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
          let elementHeight = this.$refs.element.clientHeight;

          var top  = (rectElement.top + elementHeight - (window.innerWidth > 767 ? 100 : 60)) +  scrollTop ;
          this.$store.dispatch(actionPos, top)      
          
        }
      })
      .to(balloonInnerText, {opacity: 1, duration: .5, ease:Power2.easeInOut})
    }
  },
  mounted(){
    this.userAnswer = this.selectedAnswer
    setTimeout(() => this.transitionIn(), 400)
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .chat--balloon-wrapper{
    position: relative;
    overflow: hidden;
    max-width: 504px;
    opacity: 0;
    box-sizing: border-box;
    margin-bottom: 8px;
    &.bot{
      align-self: flex-start;
    }
    &.user{
      align-self: flex-end;
    }
    @media screen and (max-width: 767px){
      max-width: 300px;
    }
  }
  .chat--balloon{
    border-radius: 20px;
    border: 1px solid #000;
    background-color: #E2E7EC;
    display: block;
    width: auto;
    padding: 16px 20px;
    font-size: 18px;
    line-height: 24px;
    box-sizing: border-box;
    &.bot{
      border-bottom-left-radius: 0;
      margin-left: 0;
      text-align: left;
    }
    &.user{
      border-bottom-right-radius: 0;
      margin-right: 0;
      margin-left: auto;
      text-align: right;
      border: 1px solid #2E70E2;
      background-color: #2E70E2;
      color: #fff;
    }
    .inner-text{
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      .emoji{
        font-size: 26px;
      }
      br{
        display: none;
      }
    }
    .balloon-content{
      position: relative;
    }
    img{
      display: block;
      width: 300px;
      margin: 0 auto;
    }
    .answer-icon{
      margin-right: 10px;
      img{
        display: block;
        width: auto;
        @media screen and (max-width: 767px) {
          width: 40px;
        }
      }
    }
    @media screen and (max-width: 767px) {
      padding: 12px 16px;
      font-size: 14px;
      line-height: 20px;
      .inner-text{
        .emoji{
          font-size: 18px;
        }
      }
    }
  }
  .dots{
    position: absolute;
    width: 60px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    opacity: 0;
    span{
      border-radius: 50%;
      background-color: #2E70E2;
      width: 15px;
      height: 15px;
      &:nth-child(1){
        animation: ballSpin 1.5s 0s ease-in-out infinite;
      }
      &:nth-child(2){
        animation: ballSpin 1.5s .25s ease-in-out infinite;
      }
      &:nth-child(3){
        animation: ballSpin 1.5s .5s ease-in-out infinite;
      }
    }
    @media screen and (max-width: 767px) {
      height: 14px;
      top: 50%;
    transform: translateY(-50%);
      span{
        width: 13px;
        height: 13px;
      }
    }
  }
  .user{
    .dots{
      span{
        background-color: #fff
      }
    }
  }
  @keyframes ballSpin {
    0%{
      transform: translateY(0);
      opacity: 1;
    }
    35%{
      opacity: .1;
    }
    50%{
      transform: translateY(-10px);
      opacity: 0;
    }
    65%{
      opacity: .1;
    }
    100%{
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>
